import axiosInstance from './axiosInstance';

// Service for fetching user-specific comments
export const getUserComments = async (userId, options = {}) => {
  try {
    const { course, video, page = 1, limit = 20 } = options;
    
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    
    if (course) params.append('course', course);
    if (video) params.append('video', video);
    
    const response = await axiosInstance.get(`/api/video-comments/user/${userId}?${params}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user comments:', error);
    throw error;
  }
};

// Service for fetching comments with user filtering
export const getCommentsWithUserFilter = async (videoId, courseId, userId = null) => {
  try {
    let url = `/api/video-comments/video/${videoId}/course/${courseId}`;
    
    if (userId) {
      url = `/api/video-comments/user/${userId}?video=${videoId}&course=${courseId}`;
    }
    
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching comments with user filter:', error);
    throw error;
  }
};

// Service for getting user comment statistics
export const getUserCommentStats = async (userId, courseId = null) => {
  try {
    const params = new URLSearchParams();
    if (courseId) params.append('course', courseId);
    
    const response = await axiosInstance.get(`/api/video-comments/user/${userId}/stats?${params}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user comment stats:', error);
    throw error;
  }
};

